import { newDappFormSchema } from '../../lib/schemas/formSchemas';

export const FORM_ID = 'dapp-form';
export const NewDappFormData = newDappFormSchema;
